module.exports = __webpack_public_path__ + "static/media/folder-solid1631f211.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/folder-solid.svg
// module id = 178
// module chunks = 0